// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.dropdown-transition__Dropdown_24cG3 {\n  max-height: auto;\n  transition: max-height 0.3s ease-in-out;\n}\n.dropdown-transition__Dropdown_24cG3.hidden__Dropdown_fnxdG {\n  overflow: hidden;\n  max-height: 0;\n}\n.active__Dropdown_3pK2k span {\n  color: #fff;\n}\n.active__Dropdown_3pK2k i {\n  color: #25aae1;\n}\n", ""]);
// Exports
exports.locals = {
	"dropdown-transition": "dropdown-transition__Dropdown_24cG3",
	"dropdownTransition": "dropdown-transition__Dropdown_24cG3",
	"hidden": "hidden__Dropdown_fnxdG",
	"active": "active__Dropdown_3pK2k"
};
module.exports = exports;
